import { render, staticRenderFns } from "./linkUser.vue?vue&type=template&id=0ea71b98&"
import script from "./linkUser.vue?vue&type=script&lang=js&"
export * from "./linkUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports